<script setup>
import i18n from "@/i18n"
import Table from "./components/Table"
import {
    onMounted, ref,
    // watch 
} from "vue"
import { useRouter } from "vue-router";
// import flatPickr from "vue-flatpickr-component";
import { database_template_name_v3 } from "@/service/index"
import { getLangValue } from "@/utils/common"; //获取后端语言
const PageHeaderT = getLangValue("product-template.title")
const PageHeaderItems = [
    {
        text: getLangValue("product-template.title"),
        active: true,
        href: "/product_template",
    },
]
// const templateName = ref("")
const searchData = ref({
    hscode: '',
    templateName: '',
    date: "",
}) // 搜索信息
const databaseList = ref([]) // 数据库list
const tableRef = ref(null) // table组件ref
const router = useRouter() // 路由
const handleSearch = () => {
    // 搜索
    tableRef.value.searchData = { ...searchData.value };
}
const addClick = () => {
    // 跳转到添加页面
    let url = router.resolve({ name: 'product_template_detail', query: { type: 'add' } }).href
    window.open(url, '_blank')
}

const getDatasBaseList = async () => {
    /**获取所有的数据库list */
    let x = true
    if (x) {
        const resp = await database_template_name_v3()
        if (resp.code == 0) {
            databaseList.value = resp.payload
        }
    }
}
const search = () => {
    // 搜索
    handleSearch()
}

const reset = () => {
    // 重置搜索条件
    searchData.value.hscode = ""
    searchData.value.templateName = ""
    searchData.value.date = []
    handleSearch()
}

onMounted(() => {
    // 获取所有的数据库list
    getDatasBaseList()
})
</script>
<template>
    <Layout>
        <PageHeader :title="PageHeaderT" :items="PageHeaderItems" />
        <div class="bg-white my-scroll-bar"
            style="overflow-x: auto; height: calc(100vh - 160px);overflow-y: hidden;border-radius: 0.25rem; ">
            <div class="p-4 d-flex justify-content-between align-items-center "
                style="box-shadow: none; font-size: 16px; font-weight: bold; color: #495057; height: 78px;">
                {{ getLangValue("product-template.title") }}
                <button v-permit="'product-template.add'" type="button" class="btn btn-success me-3" @click="addClick()"
                    style="min-width: 200px;">
                    <i class="ri-add-fill me-1 align-bottom"></i>
                    {{ getLangValue("product-template.add") }}
                </button>
            </div>
            <div class="p-4 d-flex justify-content-between" style="border-top: 1px dashed #E9EBEC;">
                <div style="flex:1" class="d-flex ">
                    <div class="w-10 mx-2 form-icon" style="max-width: 300px; flex: 1;">
                        <input type="text" class="form-control form-control-icon" v-model="searchData.hscode"
                            :placeholder="getLangValue('product-template.searchPlaceholder1')" />
                        <i class="ri-search-line"></i>
                    </div>
                    <!-- <div class="w-10 mx-2" style="position: relative; flex: 1; max-width: 252px;">
                        <flat-pickr style="width: 100%;" v-model="searchData.date"
                            :placeholder="getLangValue('product-template.createTimeRange')"
                            :config="{ enableTime: false, dateFormat: 'Y-m-d', mode: 'range', }"
                            class="form-control"></flat-pickr>
                        <i @click="searchData.date = ''" class="ri-close-circle-fill cursor-pointer"
                            style="position: absolute; right: 10px; top: 10px;color: #435185;"
                            v-if="searchData.date != null && searchData.date"></i>
                    </div> -->
                    <div class="w-10 mx-2" style="position: relative;" :title="getLangValue('attribute.create_time')">
                        <el-date-picker style="height: 37.5px;" v-model="searchData.date" type="daterange"
                            range-separator="-" :start-placeholder="getLangValue('base.start_date')"
                            :end-placeholder="getLangValue('base.end_date')" size="large" value-format="YYYY-MM-DD" />
                    </div>
                    <div class="w-10 mx-2 my-select" style="max-width: 252px; flex: 1;">
                        <el-select style="width: 100%; height: 37.5px;" v-model="searchData.templateName" filterable
                            :placeholder="getLangValue('product-template.productTemplateName1')" size="large" clearable>
                            <el-option v-for="item1 in databaseList" :key="item1.key" :label="i18n.global.locale =='en'? item1.name_en:  item1.name"
                                :value="i18n.global.locale =='en'? item1.name_en:  item1.name">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <b-button variant="success" @click="search"
                    style="min-width: 100px; background-color: #405189;display: flex;align-items: center; border-color: unset; justify-content: center;">
                    <i class="ri-search-line me-1"></i>{{ getLangValue('base.search') }}
                </b-button>
                <b-button class="mx-2" variant="success" @click="reset"
                    style="min-width: 100px;background-color: #299CDB;display: flex;align-items: center; border-color: unset; justify-content: center; ">
                    <i class="ri-refresh-line me-1"></i> {{ getLangValue('base.reset') }}
                </b-button>
            </div>
            <div style="height:calc(100% - 160px);">
                <Table ref="tableRef" />
            </div>
        </div>
    </Layout>
</template>
<style scoped lang="scss">
.my-select {
    :deep(.el-select__wrapper) {
        min-height: 37.5px;
        height: 100%;
    }
}

:deep(.el-select__placeholder.is-transparent) {
    font-size: 0.8125rem;
    color: #878a99 !important;
}

:deep(.el-select__selected-item.el-select__placeholder) {
    font-size: 0.8125rem;
    color: #212529;
}

:deep(.el-date-editor .el-range-input) {
    font-size: 0.8125rem;
    color: #212529;

    &::placeholder {
        color: #878a99 !important;
    }
}
</style>
<style>
.el-date-range-picker__header button {
    margin-top: 0 !important;
}
</style>
